import { TxStatus } from "@aztec/aztec.js";
import type { Hex } from "@turnstile-portal/turnstile.js";
import type { Address } from "viem";
import { getL2ClientAsync, waitForBlockWithProgress } from "../aztec-utils";
import { getL2Portal } from "../lib/singletons";
import { setBlockWaitingProgress } from "../state/blockWaitingProgress";

export async function claimDepositRequest(
  l1TokenAddr: Address,
  l2RecipientAddr: Address,
  amount: bigint,
  l2BlockNumber: number,
  index: bigint,
) {
  console.log(`Waiting for L2 block ${l2BlockNumber} to be mined...`);

  // Set initial progress
  setBlockWaitingProgress({ currentBlock: 0, targetBlock: l2BlockNumber, isWaiting: true });

  await waitForBlockWithProgress(
    l2BlockNumber,
    (currentBlock, targetBlock) => {
      setBlockWaitingProgress({ currentBlock, targetBlock, isWaiting: true });
    },
    2000,
    60,
  );

  // Clear the progress once we're done waiting
  setBlockWaitingProgress(null);

  const aztecPortal = await getL2Portal();
  const l2Client = await getL2ClientAsync();

  const tx = await aztecPortal.claimDeposit(l1TokenAddr, l2RecipientAddr, amount, index, { from: l2Client.getAddress(), fee: l2Client.getFeeOpts()});
  const txHash = await tx.getTxHash();

  console.log(`Claim transaction hash: ${txHash}\nWaiting for receipt...`);
  const receipt = await tx.wait();
  if (receipt.status !== TxStatus.SUCCESS) {
    throw new Error(`claimDeposit() failed. status: ${receipt.status}`);
  }
  console.log(`Deposit and claim for token ${l1TokenAddr} complete`);

  return txHash.toString();
}

export async function isClaimed(hash: Hex) {
  const aztecPortal = await getL2Portal();
  return await aztecPortal.isClaimed(hash);
}
